import { Inject, Injectable, LOCALE_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export abstract class DateTimeLocaleProvider {
    abstract locale(): string;
}

@Injectable()
export class DateTimeDefaultLocaleProvider extends DateTimeLocaleProvider {
    constructor(@Inject(LOCALE_ID) private readonly _localeId: string) {
        super();
    }

    locale(): string {
        return this._localeId;
    }
}
